import { useContext, useEffect, useState } from "react";

import { store } from "../context/store.js";
import { functions } from "../constants/common-functions";

import FilterPanelBox from "../components/FilterPanelBox";

import {
    FILTER_TYPE_FACILITY,
    FILTER_TYPE_FLOOR,
    FILTER_TYPE_SPACE_TYPE,
    FILTER_TYPE_SPACE_TYPE_SUB,
    FILTER_TYPE_ORGANISATION,
    FILTER_TYPE_ORGANISATION_SUB,

    FILTER_URL_FACILITY,
    FILTER_URL_FLOOR,
    FILTER_URL_SPACE_TYPE,
    FILTER_URL_SPACE_TYPE_SUB,
    FILTER_URL_ORGANISATION,
    FILTER_URL_ORGANISATION_SUB,

    EMPTY_FILTER_BEAN

} from "../constants/filter-constants";

export default function FilterPanel({
    refreshFunction
}) {

    const globalState = useContext(store);

    const [filterBean, setFilterBean] =
        useState(EMPTY_FILTER_BEAN);

    const queryContext =
        globalState?.state?.queryContext;

    const saveSessionFilterBean = (finalBean) => {

        functions.postFilterBeanAjax(
            "/resolutionsoftwareplatform/setfilterbean",
            functions.buildPostBodyFilterBeanQueryContext(
                finalBean,
                queryContext
            ),
            refreshFunction?.()
        );

    };

    useEffect(() => {

        const timer = setTimeout(() => {

            refreshFunction?.();

        }, 500);

        return function () {
            clearTimeout(timer);
        };

    }, [globalState]);

    const handleFilterChange = (updatedBean) => {

        setFilterBean(updatedBean);

        saveSessionFilterBean(updatedBean);

    };

    /*
     * Main architectural glass container
     */

    const thisContainer = {

        display: "flex",
        flexDirection: "row",
        alignItems: "center",

        width: "calc(100% - 60px)",
        height: "180px",

        margin: "20px",
        marginBottom: "20px",

        padding: "14px 10px",

        borderRadius: "7px",

        background:
            "linear-gradient(135deg, " +
            "rgba(22, 28, 35, 0.84) 0%, " +
            "rgba(12, 19, 27, 0.79) 55%, " +
            "rgba(8, 14, 22, 0.87) 100%)",

        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",

        border:
            "1px solid rgba(141, 200, 240, 0.15)",

        boxShadow:
            "0 8px 26px rgba(0, 0, 0, 0.28), " +
            "inset 0 1px 0 rgba(255, 255, 255, 0.05)"

    };

    /*
     * Horizontal scrolling filter area
     */

    const scrollableContent = {

        display: "flex",

        width: "calc(100% - 20px)",
        height: "100%",

        overflowX: "auto",
        overflowY: "hidden",

        scrollbarWidth: "thin",
        scrollbarColor:
            "rgba(110, 128, 145, 0.55) rgba(0, 0, 0, 0.20)"

    };

    return (

        <div
            className="omniscan-filter-panel"
            style={thisContainer}
        >

            <div
                className="omniscan-filter-panel-scroll"
                style={scrollableContent}
            >

                <FilterPanelBox
                    id="1"
                    title="Building"
                    filterType={FILTER_TYPE_FACILITY}
                    optionsUrl={FILTER_URL_FACILITY}
                    filterBean={filterBean}
                    onChange={handleFilterChange}
                />

                <FilterPanelBox
                    id="2"
                    title="Floor"
                    filterType={FILTER_TYPE_FLOOR}
                    optionsUrl={FILTER_URL_FLOOR}
                    filterBean={filterBean}
                    onChange={handleFilterChange}
                />

                <FilterPanelBox
                    id="3"
                    title="Space Type"
                    filterType={FILTER_TYPE_SPACE_TYPE}
                    optionsUrl={FILTER_URL_SPACE_TYPE}
                    filterBean={filterBean}
                    onChange={handleFilterChange}
                />

                <FilterPanelBox
                    id="4"
                    title="Space Sub Type"
                    filterType={FILTER_TYPE_SPACE_TYPE_SUB}
                    optionsUrl={FILTER_URL_SPACE_TYPE_SUB}
                    filterBean={filterBean}
                    onChange={handleFilterChange}
                />

                <FilterPanelBox
                    id="5"
                    title="Organisation"
                    filterType={FILTER_TYPE_ORGANISATION}
                    optionsUrl={FILTER_URL_ORGANISATION}
                    filterBean={filterBean}
                    onChange={handleFilterChange}
                />

                <FilterPanelBox
                    id="6"
                    title="Organisation Sub"
                    filterType={FILTER_TYPE_ORGANISATION_SUB}
                    optionsUrl={FILTER_URL_ORGANISATION_SUB}
                    filterBean={filterBean}
                    onChange={handleFilterChange}
                />

            </div>

        </div>

    );

}